module.exports = __webpack_public_path__ + "static/media/img1_1.81a74505.png";